import content from "./seo_content.json";

export const NAP = content.nap;
export const SERVICE_AREAS = content.serviceAreas;
export const DELIVERY_AREAS = content.deliveryAreas; // our own courier's reach (schema areaServed); serviceAreas = wider list the apps cover
export const CANON = content.canon;
export const OG_IMAGE = content.ogImage;
export const DELIVERY_APPS = content.deliveryApps;
export const PICKUP_REASON = content.pickupReason;
export const HOME_COPY = content.home;
export const HOME_FAQ = content.homeFaq;
export const STORY = content.story;
export const DIETARY = content.dietary;
export const FAQ = content.faq;
export const RESERVATIONS = content.reservations;
export const OWNER_LINE = content.ownerLine;
export const THREE_WAYS = content.threeWays;
export const DELIVERY_BAND = content.deliveryBand;
export const FACTS = content.facts.map((f) => f.replace("{PRICE_FACT}", content.priceFact));
export const SAME_AS = [...content.sameAs, ...(content.googleBusinessProfile ? [content.googleBusinessProfile] : [])];
export const SERVES_CUISINE = content.servesCuisine;
export const REVIEW_LINKS = content.reviewLinks;
export const AMENITY_FEATURES = ["Dine-in", "Takeout", "Delivery", "Catering", "Vegetarian options", "Vegan options", "Women-owned"]
  .map((n) => ({ "@type": "LocationFeatureSpecification", name: n, value: true }));

export const CLOSED_TUESDAY = { "@type": "OpeningHoursSpecification", dayOfWeek: "Tuesday", opens: "00:00", closes: "00:00" };
export const HOURS_SPEC = [
  { "@type": "OpeningHoursSpecification", dayOfWeek: ["Sunday", "Monday", "Wednesday", "Thursday", "Friday", "Saturday"], opens: "14:00", closes: "23:00" },
  CLOSED_TUESDAY,
];
export const TEL_MAIN = "+13129550331";
export const TEL_CATERING = "+1-312-955-0463";
export const POSTAL_ADDRESS = { "@type": "PostalAddress", streetAddress: "2660 N Halsted St", addressLocality: "Chicago", addressRegion: "IL", postalCode: "60614", addressCountry: "US" };
export const GEO = { "@type": "GeoCoordinates", latitude: 41.930889, longitude: -87.6492881 };

export function restaurantJsonLd(extra = {}) {
  return {
    "@context": "https://schema.org",
    "@type": "Restaurant",
    "@id": `${CANON}/#restaurant`,
    name: NAP.name,
    slogan: "Indian handi cooking. Punjabi roots.",
    url: CANON,
    // TODO(owner): replace with 3-5 real photos taken at the restaurant (dining room, storefront, two dishes)
    image: [`${CANON}/logo-emblem.png`],
    telephone: TEL_MAIN,
    sameAs: SAME_AS,
    contactPoint: [
      { "@type": "ContactPoint", telephone: TEL_MAIN, contactType: "reservations" },
      { "@type": "ContactPoint", telephone: TEL_CATERING, contactType: "catering" },
    ],
    servesCuisine: SERVES_CUISINE,
    amenityFeature: AMENITY_FEATURES,
    priceRange: "$$",
    hasMenu: `${CANON}/store/restaurant`,
    menu: `${CANON}/store/restaurant`,
    potentialAction: [
      {
        "@type": "OrderAction",
        target: { "@type": "EntryPoint", urlTemplate: `${CANON}/store/restaurant`, actionPlatform: ["http://schema.org/DesktopWebPlatform", "http://schema.org/MobileWebPlatform"] },
        deliveryMethod: ["http://purl.org/goodrelations/v1#DeliveryModePickUp", "http://purl.org/goodrelations/v1#DeliveryModeOwnFleet"],
      },
      {
        "@type": "ReserveAction",
        target: { "@type": "EntryPoint", urlTemplate: `${CANON}/reservations`, inLanguage: "en-US", actionPlatform: ["http://schema.org/DesktopWebPlatform", "http://schema.org/MobileWebPlatform"] },
        result: { "@type": "FoodEstablishmentReservation", name: "Table reservation at Urban Turban by VeerGi" },
      },
    ],
    acceptsReservations: true,
    address: {
      "@type": "PostalAddress",
      streetAddress: NAP.street,
      addressLocality: NAP.city,
      addressRegion: NAP.state,
      postalCode: NAP.zip,
      addressCountry: "US",
    },
    geo: { "@type": "GeoCoordinates", latitude: NAP.geo.lat, longitude: NAP.geo.lng },
    hasMap: NAP.mapUrl,
    openingHoursSpecification: [
      { "@type": "OpeningHoursSpecification", dayOfWeek: ["Sunday", "Monday", "Wednesday", "Thursday", "Friday", "Saturday"], opens: "14:00", closes: "23:00" },
      CLOSED_TUESDAY,
    ],
    areaServed: DELIVERY_AREAS.split(", ").map((n) => ({ "@type": "Place", name: `${n}, Chicago, IL` })),
    ...extra,
  };
}
